var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { SVGContainer } from ".";
import { forwardRef } from "react";
export const Search = forwardRef(function Search(_a, ref) {
    var props = __rest(_a, []);
    return (_jsx(SVGContainer, Object.assign({}, props, { ref: ref }, { children: _jsx("path", { d: "M7.8022,13.8627a6.0611,6.0611,0,1,1,6.0594-6.0582A6.0623,6.0623,0,0,1,7.8022,13.8627Zm9.9443,2.6592-3.8572-3.8564A7.7991,7.7991,0,1,0,12.6641,13.89l3.8572,3.8565a.866.866,0,1,0,1.2252-1.2243Z", fill: "currentColor" }, void 0) }), void 0));
});
//# sourceMappingURL=Search.js.map